var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "reporting" },
    [
      _c("content-wrapper", {
        scopedSlots: _vm._u([
          {
            key: "filters",
            fn: function () {
              return [
                _c("Ribbon", {
                  attrs: { assets: _vm.assets, serialNumber: _vm.serialNumber },
                  on: {
                    "selection-details": _vm.updateComponents,
                    "on-ui-toggle": _vm.updateUi,
                  },
                }),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "pl-2 pr-2" },
                  [
                    !_vm.isFinalExists
                      ? _c("div", { staticClass: "noreport border" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("noFinalAvailable")) + " "
                          ),
                        ])
                      : _vm.isDataSelected
                      ? _c("ReportGrid", {
                          staticClass: "border",
                          attrs: {
                            isNewUi: _vm.isNewUi,
                            serialNumber: _vm.serialNumber,
                            asset: _vm.selectedAsset,
                          },
                          on: { "data-loaded": _vm.openModal },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }